export default __webpack_public_path__ + "locales/tr/FilesSettings.json?hash=d77a86f62467a3fb07fa8704042d9f80";